export default __webpack_public_path__ + "static/goods-4-c0a4b47573f771b0999bcc46c2a54643.png";